import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ChatSearchView from '../component/ChatSearchView'

const ChatSearch = ({ onSearchChange }) => {
  const [value, setValue] = useState('')
  const onValueChange = ({ target }) => {
    const { value } = target
    setValue(value)
    onSearchChange(value)
  }
  return <ChatSearchView value={value} onChange={onValueChange} />
}

ChatSearch.propTypes = {
  onSearchChange: PropTypes.func,
}

export default ChatSearch
